<div class="footer-content">
    <div class="mb-4">
        <img [src]="'./assets/logo.png'" alt="image">
    </div>
    <div id="footer-contact-info">
        <div class="contact-info-wrapper">
            <div class="contact-info">
                <i class="fas fa-map-marker-alt"></i>
                <a href="https://goo.gl/maps/DdbKZa8DwozetpSk7" target="_blank">5635 S Van Dorn St, Alexandria, VA 22310</a>
            </div>
            <div class="contact-info">
                <i class="fas fa-phone-alt"></i><a href="tel:7039220777">(703) 922-0777</a>,&nbsp;<a href="tel:7036258072">(703) 625-8072</a>
            </div>
        </div>
        <div class="contact-info-wrapper">
            <div class="contact-info">
                <i class="far fa-envelope"></i>
                <a href="mailTo:bestautobody11@gmail.com">bestautobody11@gmail.com</a>
            </div>
        </div>
    </div>
</div>
<div class="copyright"><i class="far fa-copyright margin-right-1"></i>Best Auto Body 2021. All Rights Reserved.</div>
